import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from './src/components/HelloWorld.vue'
import StockList from './src/components/StockList.vue'
import StockDetail from './src/components/StockDetail.vue'
import Blog from './src/components/Blog.vue'
import Inquiry from './src/components/Inquiry.vue'
import SennheiserPromo from './src/components/SennheiserPromo.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: HelloWorld
        },
        {
            path: '/stocks',
            name: 'stocks',
            component: StockList
        },
        {
            path: '/stocks/:id(\\d+)',
            name: 'detail',
            component: StockDetail
        },
        {
            path: '/inquiry',
            name: 'inquiry',
            component: Inquiry
        },
        {
            path: '/sennheiserPromo',
            name: 'sennheiserPromo',
            component: SennheiserPromo
        },
        {
            path: '/blog',
            name: 'blog',
            component: Blog
        }
    ]
})